export default __webpack_public_path__ + "static/media/Contest.8ba75865.svg";